import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import CustomToast from "./components/common/CustomToast";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./config/AppRoutes";

const App = () => {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CustomToast />
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
